// extracted by mini-css-extract-plugin
export default {"mainScreen":"MainScreen_mainScreen__TPR-R","container":"MainScreen_container__bOHvq","sectionTitle":"MainScreen_sectionTitle__lbUjs","move-chevron":"MainScreen_move-chevron__+EOvM"};